<template>
<main class="main-wrapper flex-grow-1">
	<div class="d-flex align-items-center bg-white">
		<div class="t-headline13 t-color-headlineBlack pda-14 flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center">
			<div class="font-m">{{paymentPrice ? this.$t('451') : this.$t('914')}}</div>
		</div>
	</div>
	<div class="divider"></div>
	<!-- subtabs -->
	<div class="container container--narrow mgt-50 pdb-50">
		<!-- <div class="t-headline7  font-m">{{$t('452')}}</div> -->
		<div class="mgt-16 d-flex product-info-section">
			<div class="product-thumb square-image"  v-if="goodsThumnail">
					<img :src="goodsThumnail" alt="" >
			</div>
			<div class="product-thumb square-image"  v-else>
					<img src="/images/survey/no-carousel-image.png" alt="">
			</div>
			<div class="mgl-42 product-info flex-grow-1">
				<div class="t-headline13 font-m l-spacing6 t-line-h-30">{{goodsName}}</div>
				<div class="d-flex align-items-baseline mgt-26" v-if="!isFree()">
						<div class="t-color-headlineBlack t-body-6 pdr-4">{{currency}}</div>
						<div class="t-color-headlineBlack t-headline5 pdr-6">{{$n(paymentPrice)}}</div>
						<div class="t-body4 t-color-bodyGrayB t-line-through-red" v-if="paymentPrice != totalPrice">{{$n(totalPrice)}}</div>
				</div>
				<div class="d-flex align-items-baseline mgt-26" v-else>
						<div class="t-color-headlineBlack t-headline5 pdr-6">Free</div>
				</div>
				<div class="divider mgt-30"></div>
		<div class="t-subtitle3 font-m t-line-h-33 mgt-30">{{isFree() ? $t('916') : $t('454')}}</div>
		<div class="mgt-18">
				<span class="t-body3 t-color-bodyGrayA l-spacing42 pdr-8 font-r">{{isFree() ? $t('917') : $t('455')}}</span> 
				
				<!-- <span	class="t-body1 l-spacing48 font-r">{{orderMemberName}}</span> -->
				<span	class="t-body1 l-spacing48 font-r pdr-8">{{orderMember ?$t('3437',{first: orderMember.first, last: orderMember.last}):''}}</span>
		</div>
		<div class="mgt-18">
						<label class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
										data-mdc-auto-init="MDCTextField"
										id="ordererPhoneText"
										:class="submitState && ordererPhoneInvalidCheck ? 'mdc-text-field--invalid' : ''">
										<span class="mdc-notched-outline">
														<span class="mdc-notched-outline__leading"></span>
														<span class="mdc-notched-outline__notch">
																		<span class="mdc-floating-label" id="password-message">{{$t('456')}}</span>
														</span>
														<span class="mdc-notched-outline__trailing"></span>
										</span>
										<input class="mdc-text-field__input" type="text" 
											maxlength="50" 
											autocomplete="off"
											v-model="ordererPhone"
											id="ordererPhone"
											name="ordererPhone"
											v-validate="'required'"
											ref="ordererPhone"
										/>
										<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
														role="button">report_problem</i>
						</label>
						<div class="mdc-text-field-helper-line d-block">
										<div
														class="mdc-text-field-helper-text mdc-text-field-helper-text--persistent t-helper mdc-text-field-helper-text--validation-msg font-r ">

										</div>
						</div>
		</div>
		<div class="mgt-16">
						<label
										class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46"
										data-mdc-auto-init="MDCTextField" 
										id="ordererEmailText"
									:class="submitState && ordererEmailInvalidCheck ? 'mdc-text-field--invalid' : ''">
										<span class="mdc-notched-outline">
														<span class="mdc-notched-outline__leading"></span>
														<span class="mdc-notched-outline__notch">
																		<span class="mdc-floating-label" id="password-message">{{$t('457')}}</span>
														</span>
														<span class="mdc-notched-outline__trailing"></span>
										</span>
										<input class="mdc-text-field__input" type="text" 
											maxlength="50" 
											autocomplete="off"
											v-model="ordererEmail"
											id="ordererEmail"
											name="ordererEmail"
											v-validate="'required|email'"
											ref="ordererEmail"
										/>
										<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
														role="button">report_problem</i>
						</label>
						<div class="mdc-text-field-helper-line d-block">
							<div class="mdc-text-field-helper-text mdc-text-field-helper-text--persistent t-helper mdc-text-field-helper-text--validation-msg font-r ">
								{{$t('458')}}
							</div>
						</div>
		</div>
		<div class="mgt-40">
						<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8" v-if="isFree()" @click="requestEnrolment()" @keypress="requestEnrolment()" tabindex="0">
							<div class="mdc-button__ripple"></div>
							<span class="mdc-button__label t-body2 font-r">{{$t('921')}}</span>
						</button>
							<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8" v-else @click="next($route.params)" @keypress="next($route.params)" tabindex="0">
								<div class="mdc-button__ripple"></div>
								<span class="mdc-button__label t-body2 font-r">{{$t('459')}}</span>
						</button>
						<!-- <button class="mdc-button bg-secondaryBtn t-color-secondaryBtnText">
										<div class="mdc-button__ripple"></div>
										<span class="mdc-button__label t-body2 font-r">상품 목록으로 돌아가기</span>
						</button> -->
		</div>
			</div>
		</div>
		
	</div>
</main>
</template>

<script>
/**
 * 구매하기 - 상품 정보 컴포넌트(sales - goods information component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import memberApi from '@/api/memberApi.js'
import salesApi from '@/api/salesApi.js'
import { log } from 'util'

// Store 임포트
import {mapState, mapMutations} from 'vuex'
import {salesMixin} from '@/mixins/sales.js'

export default {
	mixins: [salesMixin],
	components: {
		// PurchaseDetail
	},
	data() {
		return {
			submitState: false,
			orderData: null,
			paymentPrice: 0,
			totalPrice: 0,
			discountPrice: 0,
			orderId: '',
			currency: '',

			goodsThumnail: '',
			goodsName: '',

			ordererData: null,
			ordererEmail: '',
			ordererPhone: '',
			orderMemberName: '',
			orderMember:'',

			ordererEmailText: null,
			ordererPhoneText: null
		}
	},
	mounted() {
		// this.$parent.setTopAppBarCloseOnly(this.$t('914'))
		this.fetchData()

		this.ordererEmailText = new MDCTextField(document.getElementById('ordererEmailText'))
		this.ordererPhoneText = new MDCTextField(document.getElementById('ordererPhoneText'))
		
		const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
			let button = new MDCRipple.attachTo(el)
			return button
		})

		window.onpopstate = function(event) {
     		this.$router.push({
				name: 'SalesDuplicate', 
				params: {goodsid: this.$route.params.goodsid}, 
				query: this.$route.query
			})
   		};

		// 자동 유효성 체크 제거(use native validation off)
		this.ordererEmailText.useNativeValidation = false
		this.ordererPhoneText.useNativeValidation = false

	},

	computed: {
		// 이메일 유효성 체크(validation email)
		ordererEmailInvalidCheck() {
			let returnValue = false
			if (this.submitState) {
				if (this.errors.has('ordererEmail')) {
					returnValue = true
				}else {
					returnValue = false
				}
			}
			this.ordererEmailText.valid === !returnValue ? '' : this.ordererEmailText.valid = !returnValue
			return returnValue
		},

		// 전화번호 유효성 체크(validation phone)
		ordererPhoneInvalidCheck() {
			let returnValue = false
			if (this.submitState) {
				if (this.errors.has('ordererPhone')) {
					returnValue = true
				}else {
					returnValue = false
				}
			}
			this.ordererPhoneText.valid === !returnValue ? '' : this.ordererPhoneText.valid = !returnValue
			return returnValue
		},
	},
	
	methods: {
		// Store 변이 정의(define store mutation)
		...mapMutations('sales', ['SET_ORDERERENAME', 'SET_ORDEREREMAIL', 'SET_ORDEREREPHONE']),

		// 주문정보 API 호출(set order information)
		async fetchData() {
			const isMicro = this.$route.query.type && this.$route.query.type === "MICRO";
			let params = this.setParams()
			let responseData = null
			try {
				const orderResult = isMicro ? await salesApi.salesMicroGoodsOrder(params) : await salesApi.salesGoodsOrder(params);	
				const response = orderResult;
				this.orderData = response.data.data
				this.paymentPrice = this.orderData.paymentPrice
				this.totalPrice = this.orderData.totalPrice
				this.discountPrice = this.orderData.discountPrice
				this.orderId = this.orderData.orderId
				this.currency = this.orderData.currency

				this.goodsThumnail = this.orderData.goods.image
				this.goodsName = this.orderData.goods.name
				let headerTitle = localStorage.getItem('brandName')
				this.$parent.setTopAppBarCustom({
					leftBtnMode: 'close',
					rightBtnMode: '',
					title: headerTitle,
					leftBtnMethod: () => {
						this.$router.push({
                            name: 'SalesDuplicate', 
                            params: {goodsid: this.$route.params.goodsid}, 
                            query: this.$route.query
						})
					},
					rightBtnMethod: '',
				})		
			} catch (err) {
				responseData = err.response.data.meta
				this.$error({content: responseData.errMsg}).then(() => {})
			}
			
			// 최근 주문자 정보(get Recent orderer information)
			salesApi.salesOrdererRecent().then((response) => {
				this.ordererData = response.data.data                
				this.ordererEmail = this.ordererData.email
				this.ordererPhone = this.ordererData.phone

				this.ordererEmailText.value = this.ordererEmail
				this.ordererPhoneText.value = this.ordererPhone
				this.orderType.value = this.$route.params.type

			}).catch((err) => {})

			// 회원 정보(get member information)
			memberApi.getMemberInfo().then((response) => {
				responseData = response.data.data
				this.orderMemberName = responseData.name.fullName
				this.orderMember = responseData.name
			})
		},

		// 파라미터 설정(set parameter)
		setParams() {
			let params = {
				goodsId: this.$route.params.goodsid,
			}
			return params
		},

		// 수강신청 API 호출(set enrollment)
		requestEnrolment() {
			let params = {}

			this.$validator.validateAll().then((resultValid) => {
				
				this.submitState = true
				if (resultValid) {
					if (this.paymentPrice <= 0) {
						params = {
							orderId: this.orderId,
							paymentMethod: '',
							returnUrl: '',
							ordererEmail: this.ordererEmail,
							ordererPhone: this.ordererPhone,
							informationConsent: true,
							depositorName: this.orderMemberName,
							data: {
								DEPOSIT_ACCOUNT_ID: ''
							}
						}
					}
					
					console.log(this.$router.query)
					let responseData = null
					salesApi.salesRequestPayment(params).then((response) => {
						responseData = response.data.data
						this.movePaymentResult()

					}).catch((err) => {
					})
				
				}
			})
		},
	},
}
</script>